import { render, staticRenderFns } from "./TemplateOverviewComponent.vue?vue&type=template&id=3655824a&scoped=true&"
import script from "./TemplateOverviewComponent.vue?vue&type=script&lang=js&"
export * from "./TemplateOverviewComponent.vue?vue&type=script&lang=js&"
import style0 from "./TemplateOverviewComponent.vue?vue&type=style&index=0&id=3655824a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3655824a",
  null
  
)

export default component.exports